export enum BusinessMemberRoleList {
  OWNER = 'OWNER',
  ADMINISTRATOR = 'ADMINISTRATOR',
  MANAGER = 'MANAGER',
  WORKER = 'WORKER'
}
